<template>

  <v-footer app
            class="pa-3"
            color="grey grey darken-1"
            dark
            height="60"
            style="z-index: 99;"
  >

    <div class="text-xs-center">
      <v-bottom-sheet v-model="bottomSheetOpen" :hide-overlay="true" inset>
        <v-btn :ripple="false" slot="activator" color="white" light>Options</v-btn>

        <v-list two-line subheader>
          <v-btn class="right" @click="bottomSheetOpen = false">Close</v-btn>
          <v-subheader>Application Options</v-subheader>

          <v-list-tile avatar>

            <v-list-tile-action>
              <v-checkbox :ripple="false" v-model="removeAnomalies"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Remove Anomalies</v-list-tile-title>
              <v-list-tile-sub-title>Toggle the filtering of anomalous data points.
              </v-list-tile-sub-title>
            </v-list-tile-content>

          </v-list-tile>

          <!--<v-list-tile avatar>-->

            <!--<v-list-tile-action>-->
              <!--<input type="number" v-model="standardDeviationFactor" style="max-width: 56px;">-->
            <!--</v-list-tile-action>-->
            <!--<v-list-tile-content>-->
              <!--<v-list-tile-title>Standard Deviation Factor</v-list-tile-title>-->
              <!--<v-list-tile-sub-title>The larger the factor, the more stray data values get through.-->
              <!--</v-list-tile-sub-title>-->
            <!--</v-list-tile-content>-->

          <!--</v-list-tile>-->

        </v-list>

      </v-bottom-sheet>
    </div>

    <v-spacer></v-spacer>

    <div>Last Updated: 2/15/2018</div>

  </v-footer>

</template>


<script>
  export default {

    name: 'Footer',

    data() {
      return {
        bottomSheetOpen: false,
        removeAnomalies: this.$store.state.universal.appOptions.removeAnomalies,
        standardDeviationFactor: this.$store.state.universal.appOptions.standardDeviationFactor,
      };
    },

    watch: {

      removeAnomalies(value) {
        this.$store.commit('SET_SENSOR_ANOMALIES', value);
      },

      standardDeviationFactor(value) {
        this.$store.commit('SET_STD_DEV_FACTOR', value);
      },

    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue